const translations = {
  en: {
    title: 'Add photo', library: 'Photo library', camera: 'Take photo', files: 'Choose file', cancelLabel: 'Cancel',
    deniedTitle: 'Camera access',
    denied: 'Camera access is off for WIW. Enable Camera in Settings, then try again.',
    restricted: 'Camera access is restricted on this device. Check Screen Time or device management settings. You can choose a photo from your library or files.',
    openSettings: 'Open Settings',
    settingsUnavailable: 'Could not open Settings. Open your device settings and select WIW.',
  },
  ru: {
    title: 'Добавить фото', library: 'Медиатека', camera: 'Сделать фото', files: 'Выбрать файл', cancelLabel: 'Отмена',
    deniedTitle: 'Доступ к камере',
    denied: 'Доступ к камере для WIW выключен. Разрешите доступ в настройках и повторите попытку.',
    restricted: 'Доступ к камере ограничен на этом устройстве. Проверьте «Экранное время» или настройки управления устройством. Можно выбрать фото из медиатеки или файлов.',
    openSettings: 'Открыть настройки',
    settingsUnavailable: 'Не удалось открыть настройки. Откройте настройки устройства и выберите WIW.',
  },
  es: {
    title: 'Añadir foto', library: 'Fototeca', camera: 'Hacer foto', files: 'Elegir archivo', cancelLabel: 'Cancelar',
    deniedTitle: 'Acceso a la cámara',
    denied: 'El acceso a la cámara está desactivado para WIW. Actívalo en Ajustes y vuelve a intentarlo.',
    restricted: 'El acceso a la cámara está restringido en este dispositivo. Revisa Tiempo de uso o los ajustes de gestión del dispositivo. Puedes elegir una foto de la fototeca o de tus archivos.',
    openSettings: 'Abrir Ajustes',
    settingsUnavailable: 'No se pudo abrir Ajustes. Abre los ajustes del dispositivo y selecciona WIW.',
  },
  fr: {
    title: 'Ajouter une photo', library: 'Photothèque', camera: 'Prendre une photo', files: 'Choisir un fichier', cancelLabel: 'Annuler',
    deniedTitle: 'Accès à l’appareil photo',
    denied: 'L’accès à l’appareil photo est désactivé pour WIW. Activez-le dans Réglages, puis réessayez.',
    restricted: 'L’accès à l’appareil photo est restreint sur cet appareil. Vérifiez Temps d’écran ou les réglages de gestion de l’appareil. Vous pouvez choisir une photo dans votre photothèque ou vos fichiers.',
    openSettings: 'Ouvrir Réglages',
    settingsUnavailable: 'Impossible d’ouvrir Réglages. Ouvrez les réglages de l’appareil et sélectionnez WIW.',
  },
  ja: {
    title: '写真を追加', library: '写真ライブラリ', camera: '写真を撮る', files: 'ファイルを選択', cancelLabel: 'キャンセル',
    deniedTitle: 'カメラへのアクセス',
    denied: 'WIWのカメラへのアクセスがオフになっています。「設定」でカメラへのアクセスを許可してから、もう一度お試しください。',
    restricted: 'この端末ではカメラへのアクセスが制限されています。「スクリーンタイム」または端末管理の設定を確認してください。写真ライブラリやファイルから写真を選ぶこともできます。',
    openSettings: '設定を開く',
    settingsUnavailable: '設定を開けませんでした。端末の設定を開き、WIWを選択してください。',
  },
  ko: {
    title: '사진 추가', library: '사진 보관함', camera: '사진 촬영', files: '파일 선택', cancelLabel: '취소',
    deniedTitle: '카메라 접근',
    denied: 'WIW의 카메라 접근이 꺼져 있습니다. 설정에서 카메라 접근을 허용한 후 다시 시도해 주세요.',
    restricted: '이 기기에서는 카메라 접근이 제한되어 있습니다. 스크린 타임 또는 기기 관리 설정을 확인해 주세요. 사진 보관함이나 파일에서 사진을 선택할 수도 있습니다.',
    openSettings: '설정 열기',
    settingsUnavailable: '설정을 열 수 없습니다. 기기 설정을 열고 WIW를 선택해 주세요.',
  },
  pt: {
    title: 'Adicionar foto', library: 'Fototeca', camera: 'Tirar foto', files: 'Escolher arquivo', cancelLabel: 'Cancelar',
    deniedTitle: 'Acesso à câmera',
    denied: 'O acesso à câmera está desativado para o WIW. Ative-o nos Ajustes e tente novamente.',
    restricted: 'O acesso à câmera está restrito neste dispositivo. Confira o Tempo de Uso ou os ajustes de gerenciamento do dispositivo. Você pode escolher uma foto da fototeca ou dos arquivos.',
    openSettings: 'Abrir Ajustes',
    settingsUnavailable: 'Não foi possível abrir os Ajustes. Abra os ajustes do dispositivo e selecione WIW.',
  },
  tr: {
    title: 'Fotoğraf ekle', library: 'Fotoğraf arşivi', camera: 'Fotoğraf çek', files: 'Dosya seç', cancelLabel: 'İptal',
    deniedTitle: 'Kamera erişimi',
    denied: 'WIW için kamera erişimi kapalı. Ayarlar’dan kamera erişimini açıp tekrar deneyin.',
    restricted: 'Bu cihazda kamera erişimi kısıtlanmış. Ekran Süresi veya cihaz yönetimi ayarlarını kontrol edin. Arşivinizden ya da dosyalarınızdan bir fotoğraf seçebilirsiniz.',
    openSettings: 'Ayarlar’ı aç',
    settingsUnavailable: 'Ayarlar açılamadı. Cihaz ayarlarını açıp WIW’i seçin.',
  },
  zh: {
    title: '添加照片', library: '照片图库', camera: '拍照', files: '选择文件', cancelLabel: '取消',
    deniedTitle: '相机访问权限',
    denied: 'WIW的相机访问权限已关闭。请在“设置”中允许访问相机，然后重试。',
    restricted: '此设备限制了相机访问。请检查“屏幕使用时间”或设备管理设置。您也可以从照片图库或文件中选择照片。',
    openSettings: '打开设置',
    settingsUnavailable: '无法打开设置。请打开设备设置并选择WIW。',
  },
  de: {
    title: 'Foto hinzufügen', library: 'Fotomediathek', camera: 'Foto aufnehmen', files: 'Datei auswählen', cancelLabel: 'Abbrechen',
    deniedTitle: 'Kamerazugriff',
    denied: 'Der Kamerazugriff für WIW ist deaktiviert. Aktiviere ihn in den Einstellungen und versuche es erneut.',
    restricted: 'Der Kamerazugriff ist auf diesem Gerät eingeschränkt. Prüfe die Bildschirmzeit oder die Einstellungen zur Geräteverwaltung. Du kannst auch ein Foto aus deiner Mediathek oder deinen Dateien auswählen.',
    openSettings: 'Einstellungen öffnen',
    settingsUnavailable: 'Die Einstellungen konnten nicht geöffnet werden. Öffne die Geräteeinstellungen und wähle WIW aus.',
  },
  it: {
    title: 'Aggiungi foto', library: 'Libreria foto', camera: 'Scatta foto', files: 'Scegli file', cancelLabel: 'Annulla',
    deniedTitle: 'Accesso alla fotocamera',
    denied: 'L’accesso alla fotocamera per WIW è disattivato. Attivalo in Impostazioni, poi riprova.',
    restricted: 'L’accesso alla fotocamera è limitato su questo dispositivo. Controlla Tempo di utilizzo o le impostazioni di gestione del dispositivo. Puoi scegliere una foto dalla libreria o dai file.',
    openSettings: 'Apri Impostazioni',
    settingsUnavailable: 'Impossibile aprire Impostazioni. Apri le impostazioni del dispositivo e seleziona WIW.',
  },
  hi: {
    title: 'फ़ोटो जोड़ें', library: 'फ़ोटो लाइब्रेरी', camera: 'फ़ोटो लें', files: 'फ़ाइल चुनें', cancelLabel: 'रद्द करें',
    deniedTitle: 'कैमरे का एक्सेस',
    denied: 'WIW के लिए कैमरे का एक्सेस बंद है। सेटिंग्स में कैमरे का एक्सेस चालू करें, फिर कोशिश करें।',
    restricted: 'इस डिवाइस पर कैमरे का एक्सेस प्रतिबंधित है। स्क्रीन टाइम या डिवाइस प्रबंधन की सेटिंग्स जाँचें। आप अपनी लाइब्रेरी या फ़ाइलों से फ़ोटो चुन सकते हैं।',
    openSettings: 'सेटिंग्स खोलें',
    settingsUnavailable: 'सेटिंग्स नहीं खुल सकीं। डिवाइस की सेटिंग्स खोलें और WIW चुनें।',
  },
};

export default translations;
